import React, { useState } from "react";
import { addInternalNote } from "../../services/internalNotesApi";
import "./InternalNotes.css";

const InternalNotes = ({
  conversationId,
  notes = [],
  onAddNote,
}) => {
  const [noteText, setNoteText] = useState("");
  const [status, setStatus] = useState("idle");

  const handleAddNote = async () => {
    // Validation
    if (!noteText.trim()) {
      setStatus("error");
      return;
    }

    // Check conversation
    if (!conversationId) {
      setStatus("error");
      return;
    }

    // Loading state
    setStatus("loading");

    try {
      // Mock API call
      const response = await addInternalNote(
        conversationId,
        noteText
      );

      // Success state
      if (response.success) {
        onAddNote(response.data);

        setNoteText("");
        setStatus("success");

        setTimeout(() => {
          setStatus("idle");
        }, 1500);
      }
    } catch (error) {
      // Error state
      setStatus("error");
    }
  };

  return (
    <div className="internal-notes">

      {/* Header */}
      <div className="internal-notes-header">
        <h3>Internal Notes</h3>
        <span>Private</span>
      </div>

      {/* Notes List */}
      <div className="internal-notes-list">

        {/* Loading State */}
        {status === "loading" && (
          <div className="notes-message">
            Saving note...
          </div>
        )}

        {/* Success State */}
        {status === "success" && (
          <div className="notes-success">
            Note added successfully!
          </div>
        )}

        {/* Empty State */}
        {status !== "loading" &&
          notes.length === 0 && (
            <div className="notes-empty">
              No internal notes yet.
            </div>
          )}

        {/* Existing Notes */}
        {status !== "loading" &&
          notes.length > 0 &&
          notes.map((note) => (
            <div
              className="internal-note"
              key={note.id}
            >
              <p>{note.text}</p>

              <small>
                {note.createdAt}
              </small>
            </div>
          ))}
      </div>

      {/* Add Note Form */}
      <div className="internal-notes-form">

        <textarea
          value={noteText}
          onChange={(e) => {
            setNoteText(e.target.value);
            setStatus("idle");
          }}
          placeholder="Add an internal note..."
          rows="4"
          disabled={status === "loading"}
        />

        {/* Error State */}
        {status === "error" && (
          <div className="notes-error">
            {!conversationId
              ? "Please select a conversation."
              : "Please enter a note before saving."}
          </div>
        )}

        {/* Add Button */}
        <button
          type="button"
          onClick={handleAddNote}
          disabled={status === "loading"}
          className="add-note-btn"
        >
          {status === "loading"
            ? "Saving..."
            : "Add Note"}
        </button>

      </div>
    </div>
  );
};

export default InternalNotes;